import { CalendarClock, ChevronRight } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { Panel, EmptyState } from "./ui";
import { zonedParts, formatTimeRange, BROWSER_TIMEZONE } from "@/lib/timezones";

const MONTH_ABBR = ["JAN", "FEB", "MAR", "APR", "MAY", "JUN", "JUL", "AUG", "SEP", "OCT", "NOV", "DEC"];

export default function UpcomingDemosCard({ demos = [], onSelect }) {
  const navigate = useNavigate();

  return (
    <Panel
      title="Upcoming Demos"
      testId="upcoming-demos-panel"
      action={<button type="button" onClick={() => navigate("/admin/demo-requests?view=calendar")} data-testid="upcoming-demos-view-calendar-btn" className="text-sm font-bold text-[#0052FF] hover:text-blue-700">View calendar</button>}
    >
      {demos.length === 0 ? (
        <EmptyState icon={CalendarClock} title="No upcoming demos." message="Scheduled demos will appear here." testId="upcoming-demos-empty" />
      ) : (
        <div className="space-y-3">
          {demos.map((demo) => {
            const parts = zonedParts(demo.start_at, BROWSER_TIMEZONE);
            return (
              <button
                key={demo.demo_request_id}
                type="button"
                onClick={() => onSelect(demo)}
                data-testid={`upcoming-demo-${demo.demo_request_id}`}
                className="flex w-full items-center gap-3 rounded-xl border border-slate-200 p-3 text-left transition-colors duration-200 hover:border-violet-200 hover:bg-violet-50/40 dark:border-white/10 dark:hover:border-violet-500/30 dark:hover:bg-violet-500/10"
              >
                <span className="flex h-11 w-11 shrink-0 flex-col items-center justify-center rounded-xl bg-violet-50 text-violet-700 dark:bg-violet-500/10 dark:text-violet-400">
                  <span className="text-[9px] font-bold uppercase leading-none">{MONTH_ABBR[parts.month - 1]}</span>
                  <span className="text-base font-extrabold leading-none">{parts.day}</span>
                </span>
                <span className="min-w-0 flex-1">
                  <span className="block truncate text-sm font-bold text-slate-950 dark:text-white">{demo.company}</span>
                  <span className="block truncate text-xs text-slate-500 dark:text-slate-400">{demo.name}</span>
                </span>
                <span className="shrink-0 text-right text-xs font-semibold text-slate-600 dark:text-slate-400">
                  {formatTimeRange(demo.start_at, demo.end_at, BROWSER_TIMEZONE, demo.duration_minutes)}
                </span>
                <ChevronRight size={15} className="shrink-0 text-slate-400 dark:text-slate-500" />
              </button>
            );
          })}
        </div>
      )}
    </Panel>
  );
}
